import React from 'react';
import { Container, Card, CardContent, Typography, Box } from '@mui/material';

function ReviewSuccess() {
  return (
    <Container maxWidth='md' sx={{ py: 4 }}>
      <Card
        sx={{
          borderRadius: 4,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
        }}
      >
        <CardContent sx={{ p: 6 }}>
          <Box textAlign='center'>
            {/* 성공 아이콘 */}
            <Box
              sx={{
                position: 'relative',
                display: 'inline-block',
                mb: 4,
              }}
            >
              {/* 배경 원 */}
              <Box
                sx={{
                  width: 200,
                  height: 200,
                  borderRadius: '50%',
                  background:
                    'linear-gradient(135deg, #4CAF50 0%, #66BB6A 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 12px 40px rgba(76, 175, 80, 0.6)',
                  position: 'relative',
                  mx: 'auto',
                }}
              >
                {/* 내부 원 */}
                <Box
                  sx={{
                    width: 160,
                    height: 160,
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {/* 커스텀 체크마크 */}
                  <Box
                    sx={{
                      position: 'relative',
                      width: 120,
                      height: 120,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: '30%',
                        top: '50%',
                        width: '25px',
                        height: '50px',
                        border: '8px solid white',
                        borderTop: 'none',
                        borderLeft: 'none',
                        transform: 'rotate(45deg) translate(-60%, -70%)',
                        filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3))',
                      },
                    }}
                  />
                </Box>
              </Box>
            </Box>

            <Typography
              variant='h2'
              fontWeight='bold'
              sx={{
                color: '#4CAF50',
                mb: 3,
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
              }}
            >
              리뷰 등록 완료!
            </Typography>

            <Typography
              variant='h5'
              sx={{
                color: '#666666',
                mb: 4,
                fontWeight: 500,
              }}
            >
              소중한 후기를 남겨주셔서 감사합니다.
            </Typography>

            <Typography
              variant='h6'
              sx={{
                color: '#888888',
                mb: 5,
                lineHeight: 1.6,
              }}
            >
              고객님의 의견은 저희 서비스 개선에 큰 도움이 됩니다.
              <br />
              앞으로도 더 나은 서비스로 보답하겠습니다.
            </Typography>

            <Box
              sx={{
                p: 4,
                backgroundColor: '#f8f9fa',
                borderRadius: 3,
                border: '2px solid #e9ecef',
              }}
            >
              <Typography
                variant='h6'
                sx={{
                  color: '#6c757d',
                  fontStyle: 'italic',
                  fontWeight: 600,
                }}
              >
                ✨ 이 창을 닫으셔도 됩니다 ✨
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
}

export default ReviewSuccess;
